import { Component, computed, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { BadgeModule } from 'primeng/badge';
import { LayoutService } from '../service/layout.service';
import { AuthService } from '../../../components/auth/data-access/auth.service';

@Component({
    selector: '[app-profilesidebar]',
    imports: [
        ButtonModule,
        DrawerModule,
        BadgeModule,
    ],
    templateUrl: 'app.profilesidebar.html',
})
export class AppProfileSidebar {
    // inject
    public authService = inject(AuthService);
    public layoutService = inject(LayoutService);

    public visible = computed(() => {
        return this.layoutService.layoutState().profileSidebarVisible
    });

    onDrawerHide() {
        this.layoutService.layoutState.update((state) => ({
            ...state,
            profileSidebarVisible: false,
        }));
    }

    onConfigButtonClick() {
        this.layoutService.showConfigSidebar();
    }

    signOut() {
        this.layoutService.resetLayout();

        this.authService.logout();
    }
}
